import Axios from "axios";
import Intellibrand from "../services/Intellibrand";

const MinimumPriceReducer = (min, current) => (current <= min) ? current : min;

export default {

    props: [
        'eansToLoad',
        'eansPerId',
    ],

    data: () => ({
        minPricePerEan: {},
        skus: {},
        selectedEan: null,
        selectedProduct: null,
        openProduct: null,
        isLoadingOffers: 0,
        isOffersModalOpen: false,
        isOffersLoadedStyle: 'none',
        productsWithOffers: 0,
        currency: Intellibrand.currency(),
        hasDecimals: Intellibrand.hasDecimals(),
        listening: false,
        videoModalIsOpen: false,
        serviceStarted: true
    }),

    mounted() {
        this.loadOffers();

        window.openOffers = (productId) => {
            if (!productId) {
                console.warn("Invalid product ID: ", productId);
                return;
            }

            if (!this.eansPerId[productId]) {
                console.warn("Product ID has no EANs mapped: ", productId);
                return;
            }

            this.selectProduct(this.eansPerId[productId])
        }
    },

    computed: {
        isOffersModalLoading() {
            return this.selectedProduct !== null && this.openProduct === null;
        }
    },

    methods: {

        listenBula(url){
            if(this.listening){
                this.listening = false;

                window.speechSynthesis.cancel();

                return true;
            }

            this.listening = true;
            Axios.get(url)
                .then(res => {
                    window.speechSynthesis.cancel();
                    let text = res.data.replace(/<\/?[^>]+(>|$)/g, "");

                    let parts = text.split(/\. |\n|, |:|!/);
                    for(let i in parts){
                        let utter = new SpeechSynthesisUtterance();

                        if(parts[i] === parts[parts.length -1]){
                            utter.onend = () => {
                                this.listening = false;
                            };
                        }

                        if(parts[i] == "" || parts[i] == " "){
                            break;
                        }

                        utter.lang = Lang._locale;
                        utter.text = parts[i];
                        utter.volume = 1;
                        utter.addEventListener("start", function(event){
                            console.log(event.utterance.text);
                        });
                        window.speechSynthesis.speak(utter);
                    }
                });
        },

        hasPriceAvailable(eans) {
            return false;
        },

        renderPrice(eans) {
            return this.currency + ("" + eans
                .map((ean) => this.minPricePerEan[ean])
                .reduce(MinimumPriceReducer, Infinity)
                .toFixed(this.hasDecimals ? 2 : 0)
            ).replace('.', ',');
        },

        selectProduct(eans) {
            this.selectedProduct = eans;
            this.openProduct = null;
            this.isOffersModalOpen = true;

            console.log("Loading offers for product w/ EANs: ", eans);

            Promise
                .all(
                    eans.map((ean) => Intellibrand.fetchOffer(ean))
                )
                .then((results) => {

                    let productsReturned = Object.values(results).filter((r) => r.ean);
                    console.log("Loaded all offers for EANs: ");
                    console.table(productsReturned);
                    if (productsReturned.length === 0) {
                        this.productsWithOffers = 0;
                        return
                    }

                    this.isOffersLoadedStyle = 'block';
                    this.openProduct = productsReturned;

                    if (productsReturned.length === 1) {
                        this.selectedEan = this.openProduct[0].ean;
                    }

                    this.$forceUpdate();
                })
        },

        onModalSkuChange(ev) {
            console.log("SELECTED EAN", ev.target.value);
            this.selectedEan = ev.target.value;
        },

        closeOffersModal() {
            this.selectedProduct = null;
            this.openProduct = null;
            this.isOffersModalOpen = false;
        },

        loadOffers() {

            let eans = this.eansToLoad.split(',');

            console.log("Loading EANs: ", eans)

            this.productsWithOffers = 0;
            eans.forEach((ean) => {
                this.isLoadingOffers++;
                Intellibrand.fetchOffer(ean)
                    .then((sku) => {

                        this.isLoadingOffers--;
                        if(!sku || sku.length === 0) {
                            return
                        }

                        if (!sku.offers) {
                            console.warn("SKU has no offers: ", sku);
                            return
                        }

                        this.skus[ean] = sku;
                        this.minPricePerEan[ean] = sku.offers
                            .map((offer) => offer.price)
                            .reduce(MinimumPriceReducer, Infinity)

                        this.$forceUpdate();
                        this.isLoadingOffers--;
                        this.productsWithOffers++
                    })
            })

        },

        checkEans(eans, idProduct) {
            let show = true;

            eans.forEach((ean) => {
                Intellibrand.fetchOffer(ean)
                .then((sku) => {
                    if (!sku.offers) {
                        show = false;
                    }
                });
            });


            if(show){
                $('.btn-sale-' + idProduct).removeClass('loading');
            }

            return show;
        }

    },

}
